import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { AlertController, ModalController } from '@ionic/angular';
import { Subscription, firstValueFrom, map } from 'rxjs';

import { AuthenticationService } from 'src/app/core/services/http/authentication.service';
import { UsuarioService } from 'src/app/core/services/http/usuario.service';
import { KeyboardKeysEnum } from '../../enums/keyboard-keys.enum';
import { ModalRoleEnum } from '../../enums/modal-role.enum';
import { UsuarioModel } from '../../models/usuario.model';

@Component({
  selector: 'app-confirmar-usuario-dialog',
  templateUrl: './confirmar-usuario-dialog.component.html',
  styleUrls: ['./confirmar-usuario-dialog.component.scss']
})
export class ConfirmarUsuarioDialogComponent implements OnInit, OnDestroy {
  private _subs$: Subscription[] = [];

  public credenciaisForm = this._formBuilder.group({
    login: ['', [Validators.required, Validators.minLength(3)]],
    senha: ['', [Validators.required, Validators.minLength(1)]]
  });
  public usuarios: UsuarioModel[] = [];

  constructor(
    private _alertCtrl: AlertController,
    private _modalCtrl: ModalController,

    private _formBuilder: FormBuilder,

    private _authenticationService: AuthenticationService,
    private _usuarioService: UsuarioService,
  ) { }

  public async cancelarAsyncOnClick() {
    await this._cancelarAsync();
  }

  private async _cancelarAsync() {
    await this._modalCtrl.dismiss(null, ModalRoleEnum.CANCEL);
  }

  public async confirmarUsuarioAsyncOnClick() {
    await this._confirmarAsync();
  }

  public ngOnDestroy(): void {
    this._subs$.forEach(l => l.unsubscribe());
  }

  public ngOnInit() {
    const sub$ = this._usuarioService
      .obterTodos()
      .pipe(map(l => l.success ? l.data : []))
      .subscribe(res => {
        this.usuarios = res;

        this._definirPrimeiroUsuarioComoSelecionado();
        this._definirFocoPrimeiroInput();
      });

    this._subs$.push(sub$);
  }

  @HostListener('document:keydown', ['$event'])
  public async _lidarComKeyboardEventAsync(event: KeyboardEvent): Promise<void> {
    switch (event.key) {
      case KeyboardKeysEnum.F5:
        event.preventDefault();
        event.stopPropagation();

        await this._confirmarAsync();
        break;
      case KeyboardKeysEnum.Escape:
        await this._cancelarAsync();
        break;
    }
  }

  private async _confirmarAsync() {
    if (await this._existeAlertaAberto()) return;

    const login = this.credenciaisForm.get('login').value;
    const senha = this.credenciaisForm.get('senha').value;

    const resultadoLogin = await firstValueFrom(this._authenticationService.login({ login, password: senha, whatsappResponsavel: '', whatsappEmpresa: '', tokenMFA: '' }, true));

    if (resultadoLogin?.usuario)
      await this._modalCtrl.dismiss(new ConfirmarUsuarioDialogDataClose(resultadoLogin.usuario), ModalRoleEnum.CONFIRM);
  }

  private _definirPrimeiroUsuarioComoSelecionado() {
    const primeiroUsuario = this.usuarios[0];

    if (primeiroUsuario) {
      this.credenciaisForm.get('login').setValue(primeiroUsuario.nome);
    }
  }

  private _obterInputs(): NodeListOf<HTMLInputElement> {
    return document.querySelectorAll('.inp') as NodeListOf<HTMLInputElement>;
  }

  public mudarFocoInputsConferenciaOnKeydownEnter(indexInputAtual: number): void {
    const inputs = this._obterInputs();
    const indexProximoInput = (indexInputAtual + 1) % inputs.length;
    const proximoInput = inputs[indexProximoInput];

    proximoInput.focus();
  }

  private _existeAlertaAberto = async () => (await this._alertCtrl.getTop()) != undefined;

  private _definirFocoPrimeiroInput(): void {
    const inputs = this._obterInputs();

    const primeiroInput = inputs[0];

    primeiroInput.focus();
  }
}

export class ConfirmarUsuarioDialogDataClose {
  constructor(
    public usuario: UsuarioModel
  ) { }
}
